// eslint-disable-next-line
const apiHost = process.browser ? process.env.apiHostBrowser : process.env.apiHostServer;
// eslint-disable-next-line
const apiPath = process.env.apiPath;
// eslint-disable-next-line
export const GET_FOOTER_LINKS_URL = `${apiHost}${apiPath}footer/menu`;
